import { api } from "./client";

export async function getSyncStatus(): Promise<import("@/types").SyncStatus> {
  const { data } = await api.get<import("@/types").SyncStatus>("/sync/status");
  return data;
}

export async function triggerIntervalsSync(): Promise<unknown> {
  const { data } = await api.post("/sync/intervals");
  return data;
}

export async function triggerWellnessSync(): Promise<unknown> {
  const { data } = await api.post("/sync/wellness");
  return data;
}
